import { BrowserRouter } from 'react-router-dom';
import MainRoute from './routers/mainRoute';
import { QueryClient, QueryClientProvider } from 'react-query';
import { lazy, Suspense } from 'react';
import LoaderComponent from './components/atom/layout/loader';
const queryClient = new QueryClient();
import { Helmet, HelmetProvider } from 'react-helmet-async';
//const MainRoute = lazy(() => import('./routers/mainRoute'));
function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <meta name="noSearch" content="noindex,nofollow" />
      </Helmet>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          {/* <Suspense fallback={<LoaderComponent />}> */}
          <MainRoute />
          {/* </Suspense> */}
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
